import React from 'react';
import { Link } from 'react-router-dom';
import { faAngleRight, faTimes } from '@fortawesome/pro-regular-svg-icons';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import './banner.css';

const Banner = ({ display, closeBanner }) => (
  <div className="banner">
    <div className="banner__container container">
      <div className="banner__content">
        <div className="banner__details">PAYMENT DELAY: Due to a routine annual review by our financial institution we have updated our payment schedule. This is temporary and should be resolved within a few weeks.</div>
        <Link to="./paymentfaq">
          <div className="banner__read-more"> Read more</div>
          <FontAwesomeIcon icon={faAngleRight} fixedWidth size="1x" />
        </Link>
      </div>
      <div className="banner__close" onClick={closeBanner}>
        <FontAwesomeIcon icon={faTimes} fixedWidth size="1x" />
      </div>
    </div>
  </div>
);

export default Banner;



// WEBPACK FOOTER //
// ./src/components/Layout/Banner.js